import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Reactions = ({ newsId }) => {
  const { user, getAuthHeader } = useAuth();
  const [reactions, setReactions] = useState({});
  const [total, setTotal] = useState(0);
  const [selectedReaction, setSelectedReaction] = useState(null);

  const reactionTypes = [
    { emoji: '😂', value: 'laugh', label: 'Laugh' },
    { emoji: '💀', value: 'dead', label: 'Dead' },
    { emoji: '🔥', value: 'fire', label: 'Fire' },
    { emoji: '👀', value: 'eyes', label: 'Eyes' },
    { emoji: '💯', value: 'hundred', label: '100' }
  ];

  useEffect(() => {
    fetchReactions();
  }, [newsId]);

  const fetchReactions = async () => {
    try {
      const response = await axios.get(`${API}/reactions/${newsId}`);
      setReactions(response.data.reactions || {});
      setTotal(response.data.total || 0);
    } catch (error) {
      console.error('Error fetching reactions:', error);
    }
  };

  const handleReaction = async (reactionType) => {
    if (!user) {
      toast.error('Login to react!');
      return;
    }

    try {
      await axios.post(
        `${API}/reactions/${newsId}`,
        { reaction_type: reactionType },
        { headers: getAuthHeader() }
      );
      setSelectedReaction(reactionType);
      fetchReactions();
      toast.success('Reaction added!');
    } catch (error) {
      toast.error('Failed to add reaction');
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`reactions-${newsId}`}>
      {reactionTypes.map((reaction) => (
        <button
          key={reaction.value}
          onClick={() => handleReaction(reaction.value)}
          data-testid={`reaction-${reaction.value}`}
          className={`flex items-center gap-1 px-3 py-1 rounded-full border-2 border-black dark:border-white transition-all ${
            selectedReaction === reaction.value
              ? 'bg-[#FFE66D] dark:bg-[#FFE66D] text-black'
              : 'bg-white dark:bg-[#2D2A26] dark:text-white hover:bg-[#F0F0F0] dark:hover:bg-[#3D3A36]'
          }`}
        >
          <span className="text-lg">{reaction.emoji}</span>
          {reactions[reaction.value] > 0 && (
            <span className="text-sm font-bold">{reactions[reaction.value]}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default Reactions;